<template>
  <div id="app" class="app">
    <RouterView class="routerview"></RouterView>
  </div>
</template>

<script>
import { RouterView } from "vue-router";
import { setAccessToken, setLogoutCallback } from "./services/api.service";
import auth from "@/utils/auth.utils";
export default {
  name: "App",
  components: {
    RouterView,
  },
  beforeCreate() {

    // Modify By Bryant 2025042801 //

//    console.log("Modify By Bryant 2025042801");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const liff_state = urlParams.get('liff.state')
    if (liff_state)
    {
      window.location.replace(liff_state);
    }

    // Modify By Bryant 2025042801 End //

    console.log("beforeCreate");
    const accessToken = this.$store.getters['userData/accessToken'];
    console.log("accessToken", accessToken);
    setAccessToken(accessToken);
    setLogoutCallback(() => {
      auth.logout();
      this.$router.push({
        path: `/${this.$store.state.basic.currentStore}`
      });
    })
  },
};
</script>

<style lang="scss">
@import "./static//css/tailwind.css";

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  // overflow: hidden;
  background-color: #eeeeee;
}

.app {
  padding: 0;
  margin: 0;
  background-color: #eeeeee;
  height: 100%;
  width: 100%;
  font-family: 'PingFang SC', Arial, Helvetica, 'Microsoft YaHei';
  color: #000000;
}

.button {
  width: 100%;
  height: 50px;
  background-color: #fbcb02;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  border: none;
  flex-shrink: 0;
  border-radius: 6px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.17);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.17);
  -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.17);
}

.scroll_flex_container {
  background-color: #eeeeee;
  width: 100%;
  height: 100svh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.scroll_flex_container::-webkit-scrollbar {
  display: none;
}
</style>
